module.exports = __webpack_public_path__ + "static/media/mp4.dc0efed9.svg";